import { render, staticRenderFns } from "./AddManufacturer.vue?vue&type=template&id=84906566&"
import script from "./AddManufacturer.vue?vue&type=script&lang=ts&"
export * from "./AddManufacturer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports